import { PayloadAction } from '../../../store.model';
import { scorePercentage } from '../../form/function/score-percentage.function';
import { Sort } from '../../grid';
import { INITIAL_MAX_ROWS } from '../fixture/initial-max-rows';
import { createNextGridState } from '../function/create-next-grid-state.function';
import { determineAllowedActions } from '../function/determine-allowed-actions.function';
import { sortRows } from '../function/sort-rows.function';
import { ActionType } from '../landing.action';
import { defaultState, LandingState } from '../landing.state';
import { GridType } from '../model/grid-type.model';

import { Reload, ReloadResult } from './reload.action';

function gridOrder(payload: ReloadResult): GridType[] {
    const nextGridOrder = [GridType.FOR_MY_TEAM];
    const forMeLength = payload.searchRets?.find(
        (e) => e.type === GridType.FOR_ME,
    )?.result?.length;
    const byMeLength = payload.searchRets?.find(
        (e) => e.type === GridType.BY_ME,
    )?.result?.length;
    if (byMeLength > forMeLength) {
        nextGridOrder.splice(0, 0, GridType.BY_ME, GridType.FOR_ME);
    } else {
        nextGridOrder.splice(0, 0, GridType.FOR_ME, GridType.BY_ME);
    }
    return nextGridOrder;
}

export function reloadReducer(
    state: LandingState,
    _: PayloadAction<ActionType.EVAL_LANDING__RELOAD, Reload>,
): LandingState {
    return {
        ...defaultState(),
        pending: {
            ...state.pending,
            reload: true,
        },
    };
}

export function reloadResultReducer(
    state: LandingState,
    action: PayloadAction<ActionType.EVAL_LANDING__RELOAD_RESULT, ReloadResult>,
): LandingState {
    const nextState: LandingState = {
        ...state,
        pending: {
            ...state.pending,
            reload: false,
        },
    };

    try {
        const nextAllowedActions = determineAllowedActions(
            action.payload.config,
        );

        const dState = defaultState();

        const nextGridOrder = gridOrder(action.payload);

        action.payload.searchRets?.forEach((ret) => {
            ret.result?.forEach((e) => {
                e.eventDate =
                    e.eventDate == null ? null : new Date(e.eventDate);
                if (e.eventDate != null) {
                    e.eventDate.setHours(0, 0, 0, 0);
                }

                e.evaluationDate =
                    e.evaluationDate == null
                        ? null
                        : new Date(e.evaluationDate);
                (e as any).percentage = scorePercentage(e.score, e.maxScore);
            });

            const ngo = createNextGridState(ret.type, state, nextState);

            let nso: Sort = null;
            switch (ret.type) {
                case GridType.FOR_ME:
                    nso = dState.forMe.sortOptions;
                    break;
                case GridType.BY_ME:
                    nso = dState.byMe.sortOptions;
                    break;
                case GridType.FOR_MY_TEAM:
                    nso = dState.forMyTeam.sortOptions;
                    // ret.result = [
                    //     ...ret.result.map(e => ({...e})),
                    //     ...ret.result.map(e => ({...e})),
                    //     ...ret.result.map(e => ({...e})),
                    //     ...ret.result.map(e => ({...e})),
                    //     ...ret.result.map(e => ({...e})),
                    //     ...ret.result.map(e => ({...e})),
                    //     ...ret.result.map(e => ({...e})),
                    //     ...ret.result.map(e => ({...e})),
                    //     ...ret.result.map(e => ({...e})),
                    // ];
                    break;
            }

            let nextFilteredRows = sortRows(ret.result, nso);
            ngo.showAllEnabled = nextFilteredRows.length > INITIAL_MAX_ROWS;
            nextFilteredRows = nextFilteredRows.slice(
                0,
                ngo.showAll ? ret.result.length : INITIAL_MAX_ROWS,
            );

            ngo.collapsed = nextGridOrder[0] !== ret.type;
            ngo.rows = ret.result;
            ngo.filteredRows = nextFilteredRows;
            ngo.sortOptions = nso;
        });

        nextState.allowedActions = nextAllowedActions;
        nextState.gridOrder = nextGridOrder;

        return nextState;
    } catch {
        nextState.forMe = {
            ...state.forMe,
            rows: null,
        };
        nextState.byMe = {
            ...state.byMe,
            rows: null,
        };
        nextState.forMyTeam = {
            ...state.forMyTeam,
            rows: null,
        };

        return nextState;
    }
}
